module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign-LeadText_90e8b702b5a0638e062dab4b6877b27f.png";